export const NotificationModule = {
    namespaced: true,
    state: {
        loadLabelData: 1,
        notiData: [],
        notiFormLoader: 1,
        totalRecord: 0,
        totalLenght: 0,
    }
}